module.exports = __webpack_public_path__ + "static/media/close.c749f0c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/close.svg
// module id = 72
// module chunks = 0